class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    this.hoverEvents?.abort();
    this.hoverEvents = new AbortController();
    const options = { signal: this.hoverEvents.signal };
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse' || !this.hoverQuery.matches || !this.closest('.header__inline-menu')) return;
      clearTimeout(this.hoverCloseTimer);
      clearTimeout(this.hoverOpenTimer);
      this.hoverOpenTimer = setTimeout(() => {
        if (!this.isConnected || !this.hoverQuery.matches) return;
        this.closest('.header__inline-menu').querySelectorAll('header-menu').forEach(menu => { if (menu !== this) menu.close(); });
        this.mainDetailsToggle.open = true;
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
      }, 100);
    }, options);
    this.addEventListener('pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(this.hoverOpenTimer);
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = setTimeout(() => {
        const focused = document.activeElement;
        if (focused && this.contains(focused) && focused.matches(':focus-visible')) return;
        this.close();
      }, 200);
    }, options);
    this.hoverQuery.addEventListener('change', () => { if (!this.hoverQuery.matches) this.close(); }, options);
    document.addEventListener('keyup', event => {
      if (event.key !== 'Escape' || !this.mainDetailsToggle.open) return;
      const returnFocus = this.contains(document.activeElement);
      this.close();
      if (returnFocus) this.mainDetailsToggle.querySelector('summary').focus({ preventScroll: true });
    }, options);
  }

  disconnectedCallback() {
    this.hoverEvents?.abort();
    clearTimeout(this.hoverOpenTimer);
    clearTimeout(this.hoverCloseTimer);
    if (this.header) this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));
  }

  close() {
    clearTimeout(this.hoverOpenTimer);
    clearTimeout(this.hoverCloseTimer);
    super.close();
    if (this.header) this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));
  }

  onToggle() {
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
